import { TICKER_ITEMS } from '../constants';
import styles from './Ticker.module.css';

export default function Ticker() {
  const items = [...TICKER_ITEMS, ...TICKER_ITEMS];
  return (
    <div className={styles.wrapper}>
      <div className={styles.track}>
        {items.map((text, i) => (
          <span key={i} className={i % 2 === 0 ? styles.highlight : styles.dim}>
            {text}
          </span>
        ))}
      </div>
    </div>
  );
}
